import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { IGroupContract } from "../../../domain/group/group-contract";
import { GroupType } from "../../../domain/group/group-type";
import { AppDialog } from "../../dialog/app-dialog.component";
import { GroupContractFormDetailComponent } from "../group-contract-form/group-contract-form-detail.component";

interface IGroupContractFormModalProps {
  open: boolean;
  onCancel: () => void;
  onSaved: () => void;
  baseContractInitialValues?: IGroupContract;
  pomContractInitialValues?: IGroupContract;
  groupType: GroupType;
  readOnly?: boolean;
}

export const GroupContractFormModal: FC<IGroupContractFormModalProps> = (props) => {
  const {
    open,
    onCancel,
    baseContractInitialValues,
    pomContractInitialValues,
  } = props;
  const { t } = useTranslation();

  return (
    <AppDialog
      open={open}
      title={t(`basedata.groups.groupContracts.contractDetails`)}
      alignButtons={"space-between"}
      onCancelClick={onCancel}
    >
      {open && baseContractInitialValues && (
        <GroupContractFormDetailComponent
          baseContractValues={baseContractInitialValues}
          pomContractValues={pomContractInitialValues}
        />
      )}
    </AppDialog>
  );
};
